import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";

import Header from './Header';
import Sidebar from './Sidebar/Sidebar';
import Content from './Content';
import SplashContainer from "../../../containers/home/SplashContainer";
import { GlobalDataContext } from "../../../contexts/GlobalDataContext";

interface Props {
  children: React.ReactNode,
}

const StyledLayout = styled.div`
  display: none;

  @media (max-width: 480px) {
    display: block;
  }
`;

const Layout = ({ children }: Props) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showSplash, setShowSplash] = useState(true);
  const [show, setShow] = useState(false);

  // @ts-ignore
  const { allDataLoaded } = useContext(GlobalDataContext);

  useEffect(() => {
    if (allDataLoaded) {
      setShow(true);
      setTimeout(() => {
        setShowSplash(false);
      }, 1500)
    }
  }, [allDataLoaded]);

  return (
    <>
    {
      (showSplash) ?
        <StyledLayout>
          <SplashContainer show={ show } />
        </StyledLayout> :
        <StyledLayout>
          <Header
            isSidebarOpen={ isSidebarOpen }
            setIsSidebarOpen={ setIsSidebarOpen }
          />
          <Sidebar isSidebarOpen={ isSidebarOpen } setIsSidebarOpen={ setIsSidebarOpen }/>
          <Content isSidebarOpen={ isSidebarOpen }>
            { children }
          </Content>
        </StyledLayout>
    }
    </>
  )
};

export default Layout;
